/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': 'Betöltés...',
	'dlg_close': 'Bezárás',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Mégse',
	'dlg_back': 'Vissza',

	// Slider
	'sliderRegionLabel': 'Csúszka vezérlőelem, a bal és a jobb nyílbillentyűkkel mozgathatja a csúszka fogópontjait',
	'sliderHandleLabel': 'Csúszka fogópontja',
	'a11ySliderHandleLabel': 'Csúszka fogópontja – %{sliderValue}',
	'sliderInputLabel': 'érték',

	// Side bar
	'sidebarAdd': 'Hozzáadás',
	'clearTextFilterValue': 'Törlés',
	'missingDataSetData': 'Az adathalmazhoz tartozó adatok nem érhetők el. Frissítse az adathalmazt, vagy lépjen kapcsolatba az adminisztrátorral a forráshoz való hozzáférésért.',

	// Toolbar
	'toolbarRegionLabel': 'Eszközsáv',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': 'Betűtípuscsalád',
	'fontSizeSelect': 'Betűméret',
	'bold': 'Félkövér',
	'italic': 'Dőlt',
	'underline': 'Aláhúzás',
	'justifyLeft': 'Balra igazítás',
	'justifyCenter': 'Középre igazítás',
	'justifyRight': 'Jobbra igazítás',
	'insertOrderedList': 'Rendezett lista',
	'insertUnorderedList': 'Rendezetlen lista',
	'fontColorPicker': 'Színválasztó',
	'textWrap': 'Szöveg tördelése',
	'restore': 'Alapértékek visszaállítása',
	// Top Bottom
	'topbottomNumberOfResultsLabel': 'Az eredmények száma',
	'topbottomPercentLabel': 'Százalék',
	'topbottomNumberOfResultsLimit': 'A lehetséges értéktartomány: %{lower} - %{higher}',
	'topbottomSelectOption': 'Első vagy utolsó lehetőség',
	'topbottomOptionLabel': 'Megjelenítés',
	'searchByLabel': 'A következő szerint:',
	'searchNoMatches': 'Nincs találat',
	'topbottomRankColumnLabel': 'Rangsoroszlop hozzáadása táblához',
	'topbottomNone': 'Nincs',
	'topCount': 'Első elemek száma',
	'topPercent': 'Felső %',
	'bottomCount': 'Utolsó elemek száma',
	'bottomPercent': 'Alsó %',
	'searchColumn': 'Oszlop keresése',
	'searchColumnAriaLabel': 'Oszlop keresése. Adja meg a keresett oszlop nevét, majd a lefelé mutató nyíllal keresse meg az oszlopot a listában',
	'rankColumnLabel': 'Rang (%{columnLabel})',
	'topbottomClearLabel': 'Törlés',

	// Format
	'formatAuto': 'Automatikus',
	'formatConvertPercent': 'Decimális átalakítása százalékká',
	'formatAbbreviate': 'Rövidítés',
	'formatUseGrouping': 'Ezres elválasztó használata',
	'dateStyle': 'Dátum stílusa',
	'dateTimeStyle': 'Dátum/Idő stílus',
	'formatMissingValueCharactersInfo': 'A hiányzó érték karakterek az érték hiányakor megjelenítendő karaktereket adják meg.',
	'currencySymbolLabel': 'Pénznemszimbólum',
	'customSymbolPlaceholder': 'Szimbólum hozzáadása',
	'customSymbolLabelInfo': 'Az egyéni szimbólumként szolgáló karakter(eke)t határozza meg. Ez a szimbólum megelőzi a számot és minden jelet. ',
	'numberLabel': 'Számcímke',
	'numberPositionLabel': 'Címke pozíciója',
	'numberLabelInfo': 'A formázott szám címkéjét határozza meg, és a címke helyzetétől függően elő- vagy utótagként kerül elhelyezésre. ',
	'nullValueDefault': '<alapértelmezett>',
	'nullValueContent': '(nincs érték)',
	'default': 'Alapértelmezett',
	'beginning': 'Kezdete',
	'end': 'Vége',

	// More data indicator
	'moreDataIndicator': 'Az adatok le lettek vágva %{threshold} elemnél. Alkalmazzon szűrőt kevesebb elem megjelenítéséhez.',

	// Expanded View / Focus mode
	'evCollapse': 'Visszazárás',
	'duplicate': 'Többszörözés',
	'copyOf': '%{name} másolata',
	'unableToDuplicateBoard': 'A(z) „%{name}” nem duplikálható.',

	// Widget list
	'errorLoadingWidgetList': 'Az objektumokat nem lehet betölteni.',

	// Custom widgets
	'customWidget': 'Egyéni eszközelem'
});
